export default __webpack_public_path__ + "static/3-2641a5cb30bc3eca147301224adf34e4.png";